import { inject } from "vue";
import { Loader } from "@googlemaps/js-api-loader";
const getAddressComponent = (place, type) => {
    return place.address_components?.find((component) => component.types.includes(type));
};
const getCountry = (place) => {
    return getAddressComponent(place, "country");
};
const getState = (place) => {
    return getAddressComponent(place, "administrative_area_level_2");
};
const getCity = (place) => {
    return getAddressComponent(place, "administrative_area_level_3");
};
const getLocality = (place) => {
    return getAddressComponent(place, "locality");
};
const getPostalCode = (place) => {
    return getAddressComponent(place, "postal_code");
};
const getStreetAddress = (place) => {
    const number = getAddressComponent(place, "street_number");
    return (getAddressComponent(place, "route")?.long_name +
        (number ? ", " + number.long_name : ""));
};
export const GoogleMapsSymbol = Symbol("Google Maps");
export const GoogleMapsService = {
    install: (app) => {
        app.provide(GoogleMapsSymbol, {
            maps: google.maps,
            getCountry,
            getState,
            getCity,
            getLocality,
            getPostalCode,
            getStreetAddress,
        });
    },
};
export function useGoogleMaps() {
    const googleMaps = inject(GoogleMapsSymbol);
    if (!googleMaps) {
        throw new Error(`Could not resolve ${GoogleMapsSymbol.description}`);
    }
    return googleMaps;
}
// export function useGeolocation() {
//     const coords = ref({ latitude: 0, longitude: 0 });
//     const isSupported = "navigator" in window && "geolocation" in navigator;
//     let watcher: number | null = null;
//     onMounted(() => {
//         watcher = navigator.geolocation.watchPosition(
//             (position) => (coords.value = position.coords)
//         );
//     });
//     onUnmounted(() => {
//         if (watcher) {
//             navigator.geolocation.clearWatch(watcher);
//         }
//     });
//     return { coords };
// }
export async function loadGoogleMaps(options) {
    return new Promise(async (resolve) => {
        const loader = new Loader(options);
        await loader.load();
        resolve(true);
    });
}
